// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.ql-toolbar.ql-snow {\r\n\tborder-color: var(--main-gray-2) !important;\n}\n.ql-container.ql-snow {\r\n\tborder-color: var(--main-gray-2) !important;\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
